/**
 * Play / pause / stop, loop and the timecode readout for the timeline.
 */

import { useVideoStore } from '@/stores/videoStore';
import { formatTimecode } from '@/lib/video/sceneTimeline';

export default function PlaybackControls() {
  const playback = useVideoStore((s) => s.playback);
  const currentTimeMs = useVideoStore((s) => s.currentTimeMs);
  const totalMs = useVideoStore((s) => s.video?.totalDurationMs ?? 0);
  const loop = useVideoStore((s) => s.loop);
  const togglePlay = useVideoStore((s) => s.togglePlay);
  const stop = useVideoStore((s) => s.stop);
  const setLoop = useVideoStore((s) => s.setLoop);
  const playing = playback === 'playing';

  return (
    <div className="vt-playback" role="group" aria-label="Playback">
      <button
        type="button"
        className="vt-btn vt-btn-play"
        title={playing ? 'Pause' : 'Play'}
        aria-label={playing ? 'Pause' : 'Play'}
        disabled={totalMs <= 0}
        onClick={togglePlay}
      >
        {playing ? '❚❚' : '▶'}
      </button>
      <button
        type="button"
        className="vt-btn"
        title="Stop"
        aria-label="Stop"
        onClick={stop}
      >
        ■
      </button>
      <button
        type="button"
        className={`vt-btn ${loop ? 'active' : ''}`}
        title="Loop"
        aria-pressed={loop}
        onClick={() => setLoop(!loop)}
      >
        ⟲
      </button>
      <span className="vt-timecode" aria-live="off">
        {formatTimecode(currentTimeMs)}
        <span className="vt-timecode-total"> / {formatTimecode(totalMs)}</span>
      </span>
    </div>
  );
}
